import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL, YEAR_OPTIONS } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { environment } from 'src/environments/environment';
import { MentoringDocumentModel } from 'common/models/page-models/mentoring-document/mentoring-document-data.model';
import {
  MentoringDocumentListingModel,
  MentoringDocumentGridPostParams,
} from 'common/models/page-models/mentoring-document/mentoring-document-grid.model';
import { TokenService } from 'common/services/core-services/get-token.service';

@Injectable({
  providedIn: 'root',
})
export class MentoringDocumentGridDataService extends GridDataService<
  MentoringDocumentListingModel,
  MentoringDocumentModel
> {
  constructor(
    http: SmApiService,
    protected override ss: SystemService,
    private tokenService: TokenService
  ) {
    super(API_URL.studentProfileMentoringDoc, http, ss);
  }

  createInstance(): MentoringDocumentListingModel {
    return new MentoringDocumentListingModel();
  }

  override getDeleteUrl(): string {
    return environment.apiUrl + API_URL.DeletestudentMentoringDoc;
  }

  override getGridParams(param): GridPostParams {
    return new MentoringDocumentGridPostParams();
  }

  override modifyGridPostParams(queryParams) {
    // let payload = this.getGridParams(queryParams);
    // const tokenDetails = this.tokenService.getDetailsFromToken(
    //   localStorage.getItem('token')
    // );
    // console.log(tokenDetails['']);
    
    
    return {};
  }

  override transformDataModel(apiRes: any, param) {
    super.transformDataModel(apiRes, param);
    apiRes[param].forEach((element) => {
      element.year =
        element.year_number === 1
          ? '1st Year'
          : element.year_number === 2
          ? '2nd Year'
          : element.year_number === 3
          ? '3rd Year'
          : '4th Year';
      // element.mentorDocument = element.mentoringDoc
        // apiRes.mentoringDoc;
        // console.log(element.mentorDocument);
        
    });
    return apiRes;
  }

  override getDeletePayload(data) {
    let payload = {
      id: [data.id],
    };
    return payload;
  }
}
